// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import ViewUI from 'view-design'
import VCharts from 'v-charts'
import 'view-design/dist/styles/iview.css'
import '../theme/index.less'
Vue.use(VueRouter)
Vue.use(ViewUI)
Vue.use(VCharts)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  ViewUI,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js